import { Select, MenuItem } from '@mui/material';

const boolSelect = (props, placeholder, yesLabel, noLabel) => (
  <Select
    variant="outlined"
    size="small"
    value={props.item.value ?? ''}
    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
    displayEmpty
    style={{ width: '100%' }}
  >
    <MenuItem value="" disabled>
      {placeholder}
    </MenuItem>
    <MenuItem value="true">{yesLabel}</MenuItem>
    <MenuItem value="false">{noLabel}</MenuItem>
  </Select>
);

export const getIsActiveFilterOperators = (translate) => {
  const t = translate || ((k, opts) => opts?._ || k);
  const yes = t('filters.yes', { _: 'Yes' });
  const no = t('filters.no', { _: 'No' });
  return [
    {
      label: t('filters.verified_is', { _: 'Verified is' }),
      value: 'verifiedEquals',
      getApplyFilterFn: (filterItem) => {
        if (filterItem.value === undefined || filterItem.value === '') return null;
        const want = filterItem.value === 'true';
        return (params) => Boolean(params.row.isVerified) === want;
      },
      InputComponent: (props) =>
        boolSelect(props, t('filters.verified_q', { _: 'Verified?' }), yes, no),
    },
    {
      label: t('filters.visible_is', { _: 'Visible is' }),
      value: 'activeEquals',
      getApplyFilterFn: (filterItem) => {
        if (filterItem.value === undefined || filterItem.value === '') return null;
        const want = filterItem.value === 'true';
        return (params) => Boolean(params.row.isActive) === want;
      },
      InputComponent: (props) =>
        boolSelect(props, t('filters.visible_q', { _: 'Visible?' }), yes, no),
    },
  ];
};

const isActiveFilterOperators = getIsActiveFilterOperators((k, opts) => opts?._ || k);

export default isActiveFilterOperators;
